/****************************************************************
Alexander Self
10/25/17

****************************************************************/
import React from 'react';

const ContentHeader = ({ field, selectedField, logo, background }) => {
  return (
    <div id="field-page-header" className="card">
      <div className="card-image waves-effect waves-block waves-light">
        <img className="activator" src={background} alt="background" />
      </div>
      <figure className="card-profile-image">
        <img src={logo} className="circle z-depth-2 responsive-img activator" alt="keaau orchards" />
      </figure>
      <div className="card-content">
        <div className="row">
          <div className="col s2 offset-s2">
            <h4 className="card-title grey-text text-darken-4">{field.id}</h4>
            <p className="medium-small grey-text">Field</p>
          </div>
          <div className="col s2 center-align">
            <h4 className="card-title grey-text text-darken-4">{selectedField.totalAcre}</h4>
            <p className="medium-small grey-text">Total Acres</p>
          </div>
          <div className="col s2 center-align">
            <h4 className="card-title grey-text text-darken-4">{selectedField.mechHarvest === null ? 0 : selectedField.mechHarvest }</h4>
            <p className="medium-small grey-text">Mechanical Harvest</p>
          </div>
          <div className="col s2 center-align">
            <h4 className="card-title grey-text text-darken-4">{selectedField.handHarvest === null ? 0 : selectedField.handHarvest }</h4>
            <p className="medium-small grey-text">Hand Harvest</p>
          </div>
          <div className="col s1 center-align">
            <h4 className="card-title grey-text text-darken-4">{selectedField.owner}</h4>
            <p className="medium-small grey-text">Group</p>
          </div>
          <div className="col s1 right-align">
            <a className="btn-floating activator waves-effect waves-light darken-2 right field-clickview">
              <i className="material-icons">assessment</i>
            </a>
          </div>
        </div>
      </div>
      <div className="card-reveal">
        <div>

        </div>
        <p>
          <span className="card-title grey-text text-darken-4">
            <span className="left">{field.id}</span>
          
            <i className="material-icons right">close</i>
          </span>
        </p>
      </div>
    </div>
  )
}

export default ContentHeader;



























/* END */



// WEBPACK FOOTER //
// ./src/components/dashboard/field/field_content_header.js